import axios from 'axios';
const oneUrl = "https://www.neww.site:446/shop"
const twoUrl = "https://www.neww.site:446/admin"
import router from '../router';
// 引入状态管理
import store from '../vuex/store';

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: oneUrl+url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: oneUrl+url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            hash: localStorage.getItem('logintoken'),
            id: localStorage.getItem('loginId')
        },
        data: params,
        traditional: true,
    }).then(res =>  {
        if(res.data.msg == "login timeout") {
            setTimeout(() => {
                store.commit('logout', 'false')
                router.push({ path: '/login' })
            }, 1000)
        } else{
            return res.data
        }
    });
};
// 通用公用方法TWO
const reqTwo = (method, url, params) => {
    return axios({
        method: method,
        url: twoUrl+url,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            hash: localStorage.getItem('logintoken'),
            id: localStorage.getItem('loginId')
        },
        data: params,
        traditional: true,
    }).then(res =>  {
        console.log(res.data)
        if(res.data.msg == "login timeout") {
            setTimeout(() => {
                store.commit('logout', 'false')
                router.push({ path: '/login' })
            }, 1000)
        } else{
            return res.data
        }
    });
};

export {
    loginreq,
    req,
    reqTwo
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js